import { Injectable } from '@angular/core';
import { AppService, BASE_URL_API } from '../../../app.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService extends AppService{

  constructor(http: HttpClient) {
    super(http);
  }

  DepartmentGetAll<T>():Observable<Object>{
    this.endpoint = `${BASE_URL_API}/department`;
    console.log(this.endpoint);
    return this.get(this.endpoint);
  }
  ProvinceGetAll<T>(dep_in_id:number):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/province/${dep_in_id}`;
    console.log(this.endpoint);
    return this.get(this.endpoint);
  }
  DistricttGetAll<T>(prv_in_id:number):Observable<Object>{
    this.endpoint = `${BASE_URL_API}/district/${prv_in_id}`;
    console.log(this.endpoint);
    return this.get(this.endpoint);
  }
}
